module.exports = __webpack_public_path__ + "static/alpha-bb643b62cc1f6c104b381fe1f9df5511.png";